/**
 *
 * @param id
 * @returns {(function(): void)|*}
 */
const copyTextToClipboard = (id) => {
  const input = document.querySelector("#" + id);

  input.readOnly = false;
  input.contentEditable = true;
  input.focus();
  input.select();

  const range = document.createRange();
  range.selectNodeContents(input);

  const s = window.getSelection();
  s.removeAllRanges();
  s.addRange(range);

  input.setSelectionRange(0, 999999);

  let successful = false;
  try {
    successful = document.execCommand("copy");
  } catch (err) {
    return false;
  }

  s.removeAllRanges();
  s.addRange(range);
  input.blur();
  input.readOnly = true;
  input.contentEditable = false;

  return successful;
};

export const copyHTMLtoClipboard = async (content) => {
  await navigator.clipboard.write([
    new ClipboardItem({
      "text/html": new Blob([content], { type: "text/html" }),
      "text/plain": new Blob([content], { type: "text/plain" }),
    }),
  ]);
};

/**
 *
 * @param content
 * @returns {Promise<void>}
 */
export const copyPlainTextToClipboard = async (content) => {
  await navigator.clipboard.write([
    new ClipboardItem({
      "text/plain": new Blob([content], { type: "text/plain" }),
    }),
  ]);
};
export default copyTextToClipboard;
